import React, {Component} from "react";
import {get} from "../helper/request";
import {error_manager} from "../helper/error_manager";
import {Divider, Grid, Typography} from "@mui/material";
import {Button, Spin} from "antd";
import {DataGrid} from "@mui/x-data-grid";
import {isNull, openInNewTab} from "../utils/utils";

const sortableHeaders = [
    {
        id: 'index',
        field: 'index',
        headerName: 'Sr no.',
        flex: 1
    },
    {
        id: 'name',
        field: 'name',
        headerName: 'Name',
        flex: 2
    },
    {
        id: 'last_updated',
        field: 'last_updated',
        headerName: 'Last Updated',
        flex: 2,
        type: 'date',
        sortComparator: (a, b) => {
            if ((a === undefined || a=== null) && (b === undefined || b=== null)) {
                return 0;
            } else if (a === undefined || a === null) {
                return -1; // Move row with undefined value to bottom
            } else if (b === undefined || b === null) {
                return 1;
            }

            const parseDate = (dateString) => {
                let date = new Date(dateString);
                if (!isNaN(date.getTime()))
                    return date;
                const [datePart, timePart] = dateString.split('-');
                const [day, month, year] = datePart.split('/');
                const [hours, minutes, seconds] = timePart.split(':');
                return new Date(`${year}/${month}/${day} ${hours}:${minutes}:${seconds}`);
            };

            const dateA = parseDate(a);
            const dateB = parseDate(b);

            return dateA.getTime() - dateB.getTime();
        },

    },
    {
        id: 'total_scans',
        field: 'total_scans',
        headerName: 'Total Scans',
        description: "Total scans starting from the first of the current month",
        flex: 2
    },
    {
        id: 'success_scans',
        field: 'success_scans',
        headerName: 'Success Scans',
        description: "Total successful scans starting from the first of the current month",
        flex: 2
    },
    {
        id: 'exported_scans',
        field: 'exported_scans',
        headerName: 'Exported',
        description: "Total exported scans starting from the first of the current month",
        flex: 2
    },
    {
        id: 'uploaded_scans',
        field: 'uploaded_scans',
        headerName: 'Uploaded',
        description: "Total uploaded scans starting from the first of the current month",
        flex: 2
    },
    {
        id: 'total_time',
        field: 'total_time',
        headerName: 'Total Time',
        description: "Total Time taken for scans starting from the first of the current month",
        flex: 2
    },
    {
        id: 'disk_stats_ssd',
        field: 'disk_stats_ssd',
        headerName: 'Disk Stats(SSD)',
        flex: 3,
        renderCell: (params) => {
            if (isNull(params.row['disk_stats_ssd'])) return <Grid>{'No data'}</Grid>;
            return <Grid container direction="column" my={2}>
                {Object.entries(params.row['disk_stats_ssd']['/']).map(([space, info]) => (
                    <>
                        <Grid item>{space}: {`${Math.round((info + Number.EPSILON) * 100) / 100} GiB`}</Grid>
                        <Divider/>
                    </>
                ))}
            </Grid>
        }
    },
    {
        id: 'disk_stats_hdd',
        field: 'disk_stats_hdd',
        headerName: 'Disk Stats(HDD)',
        flex: 3,
        renderCell: (params) => {
            if (isNull(params.row['disk_stats_hdd']) || isNull(params.row['disk_stats_hdd']['/media/scandrive']))
                return <Grid>{'No data'}</Grid>;
            return <Grid container direction="column" my={2}>
                {Object.entries(params.row['disk_stats_hdd']['/media/scandrive']).map(([space, info]) => (
                    <>
                        <Grid item>{space}: {`${Math.round((info + Number.EPSILON) * 100) / 100} GiB`}</Grid>
                        <Divider/>
                    </>
                ))}
            </Grid>
        }
    },
    {
        id: 'link',
        field: 'link',
        headerName: 'Link',
        description: 'Link to view the scanner stats in detail',
        flex: 2,
        renderCell: (params) => {
            return <Button onClick={() => {
                openInNewTab(`/scannerAnalysis/?scanner_name=${params.row.link}`)
            }}>
                [LINK]
            </Button>
        }
    },
]

class scannerAnalysisSummary extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isFetching: false,
            scannersInfo: {},
        }
    }

    componentDidMount() {
        this.getScannersInfo();
    }

    getScannersInfo = () => {
        this.setState({isFetching: true});
        get('/api/get_scanners_info')
            .then(response => {
                this.setState({isFetching: false, scannersInfo: response['scannersSummary']})
            })
            .catch(error => {
                this.setState({isFetching: false});
                error_manager("Error in fetching Scanners info", error);
            })
    }

    getScannersSummary = (val) => {
        if (isNull(val)) return;
        return Object.entries(val).map(([key, value], index) => {
            let sum_total_scan_time;
            let unit;
            try {
                sum_total_scan_time = Math.round((parseFloat(value['scannersInfo']['time'].split(" ")[0]) + Number.EPSILON) * 100) / 100;
                unit = value['scannersInfo']['time'].split(" ")[1]
            } catch (e) {
                sum_total_scan_time = Math.round((parseFloat(value['scannersInfo']['time'].toString()) + Number.EPSILON) * 100) / 100;
                unit = "Minutes";
            }
            return {
                id: index,
                index: index + 1,
                name: key.length >= 30 ? key.slice(0, -30) : key,
                last_updated: value['lastUpdated']['last_updated_readable'],
                total_scans: value['scannersInfo']['count']['total'] || 0,
                success_scans: value['scannersInfo']['count']['success'] || 0,
                exported_scans: value['scannersInfo']['count']['exported'] || 0,
                uploaded_scans: value['scannersInfo']['count']['uploaded'] || 0,
                total_time: `${sum_total_scan_time} ${unit}`,
                disk_stats_ssd: value['lastUpdated']['disks_stat'],
                disk_stats_hdd: value['lastUpdated']['disks_stat'],
                link: key,
            }
        })
    }

    changeColorBasedOnTime = (scannersInfo, params) => {
        if (isNull(scannersInfo) || scannersInfo.length === 0) return;
        const lastUpdatedData = scannersInfo[params.row.link]['lastUpdated']
        if (Object.keys(lastUpdatedData).length === 0){
            return "row-color-red"
        }
        let totalOffset = 0
        if (lastUpdatedData.timezone_offset){
            let offsetString = lastUpdatedData.timezone_offset;
            const [hoursStr, minutesStr, secondsStr] = offsetString.split(':').map(str => parseInt(str));
            totalOffset = Math.sign(hoursStr) * (Math.abs(hoursStr)*3600 + minutesStr * 60 + secondsStr);
        }

        let lastUpdatedTime = (lastUpdatedData.last_updated * 1000) - totalOffset
        let timeDifference = new Date().getTime() - lastUpdatedTime
        if (timeDifference > (24*60*60*1000)){
            return "row-color-red"
        }
        return ""
    }

    render() {
        const {isFetching, scannersInfo} = this.state;

        return <Spin spinning={isFetching}>
            <Typography sx={{margin: '10px', textAlign: 'center', fontWeight: 'bold', fontSize: '20px'}}>
                Scanners Info Dashboard
            </Typography>
            <DataGrid
                initialState={{}}
                disableRowSelectionOnClick
                autoHeight
                columns={sortableHeaders}
                rows={this.getScannersSummary(scannersInfo)}
                getRowHeight={() => 'auto'}
                getRowClassName={(params) => this.changeColorBasedOnTime(scannersInfo, params)}
            />
        </Spin>
    }

}

export default scannerAnalysisSummary;